import { render, staticRenderFns } from "./SvgStartPolit.vue?vue&type=template&id=1e7b03bc&"
import script from "./SvgStartPolit.vue?vue&type=script&lang=js&"
export * from "./SvgStartPolit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports